<div class="wrapper">
	<div class="header_block">
		<ion-icon (click)="dismiss()" class="cross" src="../../../assets/topgolf/cross.svg"></ion-icon>
	</div>
	<h3 class="title">{{ 'select_language' | translate }}</h3>

	<ul>
		@for (lang of listCountries; track lang) {
			<li>
				<div (click)="selectLng(lang.value)" class="item-wrapper">
					<div class="info_block">
						<ion-img [alt]="lang.value" [src]="lang.icon"></ion-img>
						<p>{{ lang.name }}</p>
					</div>
					<div class="circle">
						<div [class.selected]="lang.value === selectedLanguage" class="cirle_inner"></div>
					</div>
				</div>
			</li>
		}
	</ul>
	<div class="footer-item">
		<ion-button (click)="dismissWithData()"> {{ 'checkout_modal.confirm' | translate }}</ion-button>
	</div>
</div>
